import React, { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { AppDispatch, RootState } from '../../redux/store';
import { EmptyPage } from '../EmptyPage';
import { Input } from '../../components/Input';
import { PhoneInput } from '../../components/Input/PhoneInput';
import { Button } from '../../components/Button';
import { flattenPermissions, generatePassword, createPermsObject, validateUserFields } from '../../helpers';
import { EnumsSelector } from './EnumsSelector';
import { Select } from '../../components/Select';
import { createUser } from '../../redux/userSlice';
import { CLIENT_NOTS, getClientNotify } from '../../redux/notifySlice';

const hasFullAccess = (permissions) => {
  for (const key in permissions) {
    if (!permissions[key].flag) {
      return false;
    }
  }
  return true;
}

function renderPermissions(template, permissions, setPermissions, setPermsList, thisUserPerms, parentFlag = false) {
  return Object.entries(template).map(([key, value]) => {
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      // Если текущее значение является объектом, рекурсивно рендерим его
      const [popup, setPopup] = useState(false);
      const setEnumsHandler = (id) => {
        const listName = permissions[key].enums.name;
        if (permissions[key][listName].some((eId) => eId === id)) {  //Добавляем в список
          const newList = permissions[key][listName].filter((eId) => eId !== id);
          setPermsList(key, newList);
          return;
        }
        const newList = [...permissions[key][listName], id];
        setPermsList(key, newList);
      }
      const setPermsHandler = (e) => {
        const {checked} = e.target;
        setPermissions(key, checked);
      }

      const level = permissions[key].level;
      const {enums} = permissions[key];
      const listName = enums?.name;
      const colorClassName = permissions[key].flag ? 'green' : permissions[key][listName]?.length ? 'yellow' : '';
      const hasAllAccess = thisUserPerms[key].flag
      const hasSomeAccess = hasAllAccess || !!enums?.list?.length;
      const isSelectDisabled = permissions[key].flag || !parentFlag;
      
      return level > 1 ? (<React.Fragment key={key}>
        {hasSomeAccess && <div className='access__item' style={{marginLeft: `${level*16}px`}}>
          {popup && <EnumsSelector selectedEnums={permissions[key][listName]} selectEnums={(id) => setEnumsHandler(id)} enums={enums.list} closeFn={() => setPopup(false)} title={enums.title}/>}
          <input
              type="checkbox"
              className={`${!hasAllAccess ? 'disabled' : ''}`}
              checked={permissions[key].flag}
              disabled={!hasAllAccess}
              title={value.description}
              id={key}
              onChange={setPermsHandler}
            />
          <label className={`${colorClassName} ${!hasAllAccess ? 'disabled' : ''}`} htmlFor={key} title={value.description}>{value.label}</label>
          {enums &&<div className='button-container'>
            <span className={`select-button ${isSelectDisabled ? 'disabled':''}`} onClick={isSelectDisabled ? null : () => setPopup(true)}>...или только выбранных</span>
            {!!permissions[key][listName]?.length && <span style={{marginLeft: '6px', color: 'yellow'}}>(выбрано: {permissions[key][listName].length})</span>}
          </div>}
          </div>}
          {renderPermissions(value, permissions, setPermissions, setPermsList, thisUserPerms, permissions[key].flag)}
      </React.Fragment>) : (<React.Fragment key={key}>
        <div className={`access__category ${!level ? 'full-width' : ''}`}>
        <div className='access__item' style={{marginLeft: `${level*16}px`}}>
          {popup && <EnumsSelector selectedEnums={permissions[key][listName]} selectEnums={(id) => setEnumsHandler(id)} enums={enums.list} closeFn={() => setPopup(false)} title={enums.title}/>}
          <input
              type="checkbox"
              checked={permissions[key].flag}
              title={value.description}
              id={key}
              onChange={setPermsHandler}
            />
          <label className={colorClassName} htmlFor={key} title={value.description}>{value.label}</label>
          {enums &&<div className='button-container'>
            <span className={`select-button ${isSelectDisabled ? 'disabled':''}`} onClick={isSelectDisabled ? null : () => setPopup(true)}>...или только выбранных</span>
            {!!permissions[key][listName]?.length && <span style={{marginLeft: '6px', color: 'yellow'}}>(выбрано: {permissions[key][listName].length})</span>}
          </div>}
          </div>
          {!!level && renderPermissions(value, permissions, setPermissions, setPermsList, thisUserPerms, permissions[key].flag)}
          </div>
          {!level && renderPermissions(value, permissions, setPermissions, setPermsList, thisUserPerms, permissions[key].flag)}
          </React.Fragment>)
    } else {
      return null;
    }
  });
}

export const CreateUser = ({}) => {

  const userInfo = useSelector((state) => state.auth);

  const cities = useSelector((state) => state.settings.userCities);
  const cityList = cities.length ? cities : [{_id: null, name: 'Нет доступных городов'}];
  const profiles = useSelector((state) => state.settings.userProfiles);
  const settings = useSelector((state) => state.settings);
  const users = useSelector((state) => state.users.list);

  const [login, setLogin] = useState('');
  const [pass, setPass] = useState('');
  const [fullname, setFullname] = useState('');

  const [phone, setPhone] = useState('');
  const [files, setFiles] = useState([]);
  const [city, setCity] = useState(cityList[0]._id);
  const fileInputRef = useRef(null);

  const [roleName, setRoleName] = useState('');
  const [privilegeLevel, setPrivilegeLevel] = useState(String(userInfo.role.privilegeLevel-1));
  const setPrivilegeLevelHandler = (level) => {
    if (level < userInfo.role.privilegeLevel && !isNaN(+level) && level > 0) {
      setPrivilegeLevel(String(level));
    }
  }

  const setFilesHandler = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles(selectedFiles);
  };
  const clickInputHandler = () => {
    fileInputRef.current.click()
  }

  const [selectedProfiles, selectProfile] = useState([]);
  const selectProfileHandler = (profId) => {
    if (selectedProfiles.some(pId => pId === profId)) {
      selectProfile(selectedProfiles.filter(pId => pId !== profId));
      return;
    }
    selectProfile([...selectedProfiles, profId]);
  }

  const generatePassHandler = () => {
    return generatePassword(15,true,true,true,true);
  }

  const withEnums = (perms) => {
    perms.ALL_CITY_ORDERS.enums = {list: settings.orderCities, name: 'cities', title: 'города'};
    perms.ALL_PROFILE_ORDERS.enums = {list: settings.orderProfiles, name: 'profiles', title: 'профили'};
    perms.ALL_USER_ORDERS.enums = {list: settings.orderUsers.map((uId) => ({_id: uId, name: users.find((u) => u._id === uId)?.fullname})).filter(u => u), name: 'users', title: 'пользователей'};

    perms.ALL_CITY_OFFICE.enums = {list: settings.officeCities, name: 'cities', title: 'города'};
  
    perms.ALL_USERS.enums = {list: settings.availableUsers, name: 'users', title: 'пользователи'};
    perms.ALL_PROFILES.enums = {list: settings.userProfiles, name: 'profiles', title: 'профили'};
    perms.ALL_CITIES.enums = {list: settings.userCities, name: 'cities', title: 'города'};
    perms.ALL_CITY_ADVERT.enums = { list: settings.advertCities, name: 'cities', title: 'города' };
    return perms;
  }

  const permissionTemplate = useSelector((state) => state.settings.permissionSchema);
  const [permissions, setPermissions] = useState(withEnums(flattenPermissions(permissionTemplate)));
  const thisUserPerms = flattenPermissions(userInfo.role.permissions);

  const setPermsHandler = (key, flag) => {
    const {path, level} = permissions[key];
    const changedState = {...permissions};
    if (flag) {
      path.forEach((k) => changedState[k] = {...permissions[k], flag});
      if (changedState[key].enums) {
        changedState[key][changedState[key].enums.name] = [];
      }
    } else {
      changedState[key] = {...permissions[key], flag};
      for (const k in permissions) {
        if (permissions[k].path[level] === key) {
          changedState[k] = {...permissions[k], flag} //Ставим false дочерним
        }
        const enumList = changedState[k][changedState[k].enums?.name];
        if (enumList) { //Если у текущего права есть список
          changedState[k].path.forEach((k2, index, arr) => {  //Тогда проверим все родительские на false
            if (!changedState[k2].flag && index !== arr.length-1) {  //Кроме последнего пути (текущий уровень)
              changedState[k][changedState[k].enums.name] = [];
              return;
            }
          })
        }
      }
    }
    setPermissions({...permissions, ...changedState});
  }

  const setPermsListHandler = (key, list) => {
    setPermissions({
      ...permissions,
      [key]: {
        ...permissions[key],
        flag: false,
        [permissions[key].enums.name]: list
      }});
  }

  const setFullAccess = () => {
    const newPerms = {...permissions};
    for (const key in newPerms) {
      newPerms[key].flag = true;
      if (newPerms[key].enums) {
        newPerms[key][newPerms[key].enums.name] = [];
      }
    }
    setPermissions(newPerms);
  }
  const dispatch = useDispatch();
  const [isButtonBlocked, setButtonBlocked] = useState(false);
  const resetFields = () => {
    setButtonBlocked(false);
    setLogin('');
    setPass('');
    setFullname('');
    setPhone('');
    setFiles([]);
    setCity(cityList[0]._id);
    selectProfile([]);
    setPermissions(withEnums(flattenPermissions(permissionTemplate)));
    setRoleName('');
    setPrivilegeLevel(String(userInfo.role.privilegeLevel-1));
  }
  const createUserHandler = () => {
    const body = {
      fullname,
      telegramId: +login,
      password: pass,
      city,
      profiles: selectedProfiles,
      role: {
        name: roleName,
        privilegeLevel: +privilegeLevel,
        permissions: createPermsObject(permissionTemplate, permissions)
      },
      personalData: {
        phoneNumber: phone || null,
        documents: files,
      },
    };
    const validateResult = validateUserFields(body);
    if (!validateResult.isOkay) {
        dispatch(getClientNotify({
            data: validateResult,
            action: CLIENT_NOTS.EMPTY_FIELD,
        }));
        return;
    }
    setButtonBlocked(true);
    dispatch(createUser({userData: body, resetFunc: resetFields, unlockButton: () => setButtonBlocked(false)}));
  }
  return (
    <div className='edit-user-page edit-user page'>
      <h2 className="edit-user__title">Создание нового пользователя</h2>
      <div className="edit-user__body">
        <fieldset className='general dark-theme-bg0'>
          <legend>Основное</legend>
          <Input value={login} label='Логин' placeholder='telegramId' changeHandler={(e) => setLogin(e.target.value)}/>
          <div className='password'>
            <Input value={pass} label='Пароль' placeholder='Пароль' changeHandler={(e) => setPass(e.target.value)}/>
            <Button text='сгенерировать' onClick={() => setPass(generatePassHandler())}/>
          </div>
          <Input value={fullname} label='Полное имя' placeholder='Имя Фамилия' changeHandler={(e) => setFullname(e.target.value)}/>
        </fieldset>
        <fieldset className='personal dark-theme-bg0'>
          <legend>Персональные данные</legend>
          <label className='input__label'>Телефон
            <PhoneInput value={phone} changeHandler={(e) => setPhone(e.target.value)}/>
          </label>
          <Select label='Город' enums={cityList} value={city} changeHandler={(e) => setCity(e.target.value)}/>
          <label className="input__label">Документы
            <input accept=".jpg,.jpeg,.png" style={{display: 'none'}} ref={fileInputRef} type='file'  multiple={true} onChange={setFilesHandler}/>
            <Button text={!files.length ? 'выбрать фото' : `выбрано ${files.length} фото`} onClick={clickInputHandler} />
            {!!files.length && <span style={{marginTop: '2px'}} onClick={() => setFiles([])}>Сбросить фотографии</span>}
          </label>
        </fieldset>
        <fieldset className='profiles dark-theme-bg0'>
          <legend>Профили</legend>
          <p>Укажите, по каким профилям будет работать пользователь:</p>
          <div>
            {profiles.map(p => <Button key={p._id} classNames={selectedProfiles.some(pId => pId === p._id) ? 'active' : ''} text={p.name} onClick={() => selectProfileHandler(p._id)}/>)}
            {!profiles.length && 'Нет доступных профилей'}
          </div>
        </fieldset>
        <fieldset className='access dark-theme-bg0'>
          <legend>Доступ</legend>
          {hasFullAccess(thisUserPerms) && <Button text='выдать полный доступ' onClick={setFullAccess}/>}
          <div className="access__list">
            {renderPermissions(permissionTemplate, permissions, setPermsHandler, setPermsListHandler, thisUserPerms)}
          </div>
          <Input value={roleName} label='Роль' placeholder='Роль пользователя' changeHandler={(e) => setRoleName(e.target.value)}/>
          <Input type='number' value={privilegeLevel} label={`Уровень привилегий (не более ${userInfo.role.privilegeLevel-1})`} placeholder='Число-уровень привилегий' changeHandler={(e) => setPrivilegeLevelHandler(e.target.value)}/>
        </fieldset>
      </div>
      <div className="edit-user__footer">
        <Button disabled={isButtonBlocked} text='создать пользователя' onClick={createUserHandler}/>
      </div>
    </div>
  )
}
